import { ThunkService } from '../../services/thunkService';
import * as StM from '../../models/store';

export class EditUserAdminDialogActions {
    static open(userId: string, sectionType?: string): (dispatch: any, getState: () => StM.IGlobalStoreState, thunkService: ThunkService) => void {
        return (dispatch: any, getState: () => StM.IGlobalStoreState, thunkService: ThunkService) => {
            dispatch({
                type: 'Dialogs/Admin/EditUser/Open',
                userId: userId,
                sectionType: sectionType
            });
        };
    }

    static close(): (dispatch: any, getState: () => StM.IGlobalStoreState, thunkService: ThunkService) => void {
        return (dispatch: any, getState: () => StM.IGlobalStoreState, thunkService: ThunkService) => {
            dispatch({
                type: 'Dialogs/Admin/EditUser/Close',
            });
        };
    }
}